import { render, staticRenderFns } from "./GroupSessionInvitationNotification.vue?vue&type=template&id=6060c3dc&scoped=true&"
import script from "./GroupSessionInvitationNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionInvitationNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060c3dc",
  null
  
)

export default component.exports